// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-100-k-index-js": () => import("/Users/miked/Documents/smartfinancenews.com/src/pages/100k/index.js" /* webpackChunkName: "component---src-pages-100-k-index-js" */),
  "component---src-pages-404-js": () => import("/Users/miked/Documents/smartfinancenews.com/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/miked/Documents/smartfinancenews.com/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/miked/Documents/smartfinancenews.com/.cache/data.json")

